import axioPath from "api/axioPath";
import axios from "axios";
import { UPDATE_DATA } from "redux/actions/action_types";

export const registerUser = (data) => (dispatch) => {
  return axioPath
    .post("/auth/register", data)
    .then((response) => {
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return { error: false, data: response.data };
    })
    .catch((ex) => {
      if (typeof ex == "string") {
        return { ex: { message: ex } };
      }
      return { error: true, data: ex.response?.data };
    });
};

export const emailValidateApi = (email) => (dispatch) => {
  return axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: {
      "Content-Type": "application/json",
    },
  }).get("/auth/email_exist?email=" + email)
    .then((response) => {
      dispatch({ type: UPDATE_DATA, payload: response.data, apiType: "form" });
      return { error: false, data: response.data };
    })
    .catch((ex) => {
      if (typeof ex == "string") {
        return { ex: { message: ex } };
      }
      return { error: true, data: ex.response?.data };
    });
};

export const zipCodeValidate = (zipCode, country) => (dispatch) => {
  return axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: {
      "Content-Type": "application/json",
    },
  }).get("/internal/validate_zip_code/" + zipCode + "/" + (country || 'USA'))
    .then((response) => {
      dispatch({ type: UPDATE_DATA, payload: response.data, apiType: "form" });
      return { error: false, data: response.data };
    })
    .catch((ex) => {
      if (typeof ex == "string") {
        return { ex: { message: ex } };
      }
      return { error: true, data: ex.response?.data };
    });
};
